import React from 'react';

export const CleanlinessLeftImage = () => {
  return (
    <div className="il-add" style={{ backgroundImage: `url("/img/cleanliness/cleanliness-left.jpeg")`}}></div>
  );
};